export default __webpack_public_path__ + "static/media/zuckerberg1.de0e335e.png";